// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification_wrapper__ewpKs {
  position: fixed;
  top: 20px;
  left: calc(50% - 200px);
  width: 400px;
  height: max-content;
  display: flex;
  flex-direction: column;
  gap: 10px;
  transition: all 0.3s;
  z-index: 10001; }

.notification_container__T-NsI {
  width: 400px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 4px;
  font-weight: 400;
  font-size: 16px;
  line-height: 175%;
  opacity: 1; }
  .notification_container__T-NsI > a {
    display: flex;
    align-items: center;
    text-decoration: none; }
  .notification_container__T-NsI span {
    margin-left: 10px; }

.notification_error__T6Kbf {
  background: #f6cbcb;
  border: 2px solid #e00606;
  color: #b00808; }
  .notification_error__T6Kbf > a {
    color: #b00808; }

.notification_success__qcRlk {
  background: #e3f3d0;
  border: 2px solid #87bc45;
  color: #629424; }
  .notification_success__qcRlk > a {
    color: #629424; }

.notification_warning__6ZGNu {
  background: linear-gradient(0deg, rgba(254, 97, 0, 0.1), rgba(254, 97, 0, 0.1)), #ffffff;
  border: 2px solid #fe6100;
  color: #b62f00; }
  .notification_warning__6ZGNu > a {
    color: #b62f00; }

.notification_info__8qKdD {
  background: linear-gradient(0deg, #ccfaff, #ccfaff), #ffffff;
  border: 2px solid #00a9ff;
  color: #0062b7; }
  .notification_info__8qKdD > a {
    color: #0062b7; }

.notification_hide__2NTwS {
  display: none; }

.notification_cross__K7QG\\+ {
  cursor: pointer;
  transition: all 0.4s; }
  .notification_cross__K7QG\\+:hover {
    transform: scale(1.1); }
`, "",{"version":3,"sources":["webpack://./src/components/notificationSocket/notification.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;EACpB,cAAc,EAAA;;AAEhB;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,UAAU,EAAA;EAVZ;IAYI,aAAa;IACb,mBAAmB;IAEnB,qBAAqB,EAAA;EAfzB;IAkBI,iBAAiB,EAAA;;AAGrB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc,EAAA;EAHhB;IAKI,cAAc,EAAA;;AAGlB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc,EAAA;EAHhB;IAKI,cAAc,EAAA;;AAGlB;EACE,wFAAwF;EACxF,yBAAyB;EACzB,cAAc,EAAA;EAHhB;IAKI,cAAc,EAAA;;AAGlB;EACE,4DAA4D;EAC5D,yBAAyB;EACzB,cAAc,EAAA;EAHhB;IAKI,cAAc,EAAA;;AAGlB;EACE,aAAa,EAAA;;AAEf;EACE,eAAe;EACf,oBAAoB,EAAA;EAFtB;IAII,qBAAqB,EAAA","sourcesContent":[".wrapper {\n  position: fixed;\n  top: 20px;\n  left: calc(50% - 200px);\n  width: 400px;\n  height: max-content;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  transition: all 0.3s;\n  z-index: 10001;\n}\n.container {\n  width: 400px;\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 4px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 175%;\n  opacity: 1;\n  > a {\n    display: flex;\n    align-items: center;\n\n    text-decoration: none;\n  }\n  span {\n    margin-left: 10px;\n  }\n}\n.error {\n  background: #f6cbcb;\n  border: 2px solid #e00606;\n  color: #b00808;\n  > a {\n    color: #b00808;\n  }\n}\n.success {\n  background: #e3f3d0;\n  border: 2px solid #87bc45;\n  color: #629424;\n  > a {\n    color: #629424;\n  }\n}\n.warning {\n  background: linear-gradient(0deg, rgba(254, 97, 0, 0.1), rgba(254, 97, 0, 0.1)), #ffffff;\n  border: 2px solid #fe6100;\n  color: #b62f00;\n  > a {\n    color: #b62f00;\n  }\n}\n.info {\n  background: linear-gradient(0deg, #ccfaff, #ccfaff), #ffffff;\n  border: 2px solid #00a9ff;\n  color: #0062b7;\n  > a {\n    color: #0062b7;\n  }\n}\n.hide {\n  display: none;\n}\n.cross {\n  cursor: pointer;\n  transition: all 0.4s;\n  &:hover {\n    transform: scale(1.1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `notification_wrapper__ewpKs`,
	"container": `notification_container__T-NsI`,
	"error": `notification_error__T6Kbf`,
	"success": `notification_success__qcRlk`,
	"warning": `notification_warning__6ZGNu`,
	"info": `notification_info__8qKdD`,
	"hide": `notification_hide__2NTwS`,
	"cross": `notification_cross__K7QG+`
};
export default ___CSS_LOADER_EXPORT___;
